const B64_PREFIX = 'b64:';

/**
 * Encodes a string as UTF-8 and wraps it in the "b64:" transport prefix so the
 * Helios backend can safely transport SQL (and other payloads) that contain
 * characters outside of Latin-1 (which `btoa` cannot handle natively).
 *
 * The matching backend decoder lives in `SqlQueryExtensions.DecodeFromTransport`.
 */
export const encodeSqlForTransport = (sql: string): string => {
  if (!sql) return '';
  // `btoa` only handles Latin-1; convert the UTF-16 string to a percent-encoded
  // ASCII form, decode it back as raw bytes, then base64-encode the result.
  const utf8 = unescape(encodeURIComponent(sql));
  return `${B64_PREFIX}${btoa(utf8)}`;
};
